import type {
  ProfessionalOnlineStatus,
  ServiceChannels,
} from '@klaro7/shared-types';

export const MY_PROFESSIONAL_PROFILE_QUERY_KEY = ['professional-profile', 'me'] as const;

interface CachedProfessionalRecord {
  onlineStatus?: ProfessionalOnlineStatus;
  serviceChannels?: ServiceChannels;
  professional?: CachedProfessionalRecord;
  [key: string]: unknown;
}

export function getCachedProfessional(data: unknown): CachedProfessionalRecord | null {
  if (!data || typeof data !== 'object') return null;
  const record = data as CachedProfessionalRecord;
  return record.professional ?? record;
}

export function getCachedServiceChannels(data: unknown): ServiceChannels {
  const professional = getCachedProfessional(data);
  if (!professional) {
    return { chat: false, audioCall: false, videoCall: false };
  }
  const channels = professional.serviceChannels;
  return {
    chat: channels?.chat ?? true,
    audioCall: channels?.audioCall ?? true,
    videoCall: channels?.videoCall ?? true,
  };
}

export function patchCachedProfessional(
  data: unknown,
  patch: Partial<CachedProfessionalRecord>
): unknown {
  if (!data || typeof data !== 'object') return data;
  const record = data as CachedProfessionalRecord;
  if (record.professional) {
    return { ...record, professional: { ...record.professional, ...patch } };
  }
  return { ...record, ...patch };
}
